import api from './index';

const getStudentDashboardList = () => api.get(`/Student_dashboard/count`);
const getStudentDashboardReports = () => api.get(`/Student_dashboard/reports`);

const getStudentDashboardAssessmentList = () =>
  api.get(`/Student_dashboard/user/count`);

export {
  getStudentDashboardList,
  getStudentDashboardAssessmentList,
  getStudentDashboardReports,
};
